export default __webpack_public_path__ + "static/media/logo.21f53d66.png";